/* eslint-disable import/prefer-default-export */
export function isFileValidate(file: File, types: string[], size = 5000000000): boolean {
  return file?.size <= size && types.includes(file?.type.split('/')[0])
}

export function isFileValidateFullType(file: File, types: string[], size = 5000000000): boolean {
  return file?.size <= size && types.includes(file?.type)
}
